import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

export default class ServicesRecords {
  static async getAll(query) {
    const accessToken = JSON.parse(localStorage.getItem('accessToken'));
    let page = query.page ?? 1;
    let limit = query.limit ?? 10;

    let url = `${adminUrl}/services-records?page=${page}&limit=${limit}`;

    if (query.userId != null && query.userId.length != 0) {
      url = url + `&userId=${query.userId}`;
    }
    if (query.membershipId != null && query.membershipId.length != 0) {
      url = url + `&membershipId=${query.membershipId}`;
    }
    if (query.servicePlanId != null && query.servicePlanId.length != 0) {
      url = url + `&servicePlanId=${query.servicePlanId}`;
    }
    if (query.isolatedServiceId != null && query.isolatedServiceId.length != 0) {
      url = url + `&isolatedServiceId=${query.isolatedServiceId}`;
    }
    if (query.refundable != null && query.refundable.length != 0) {
      url = url + `&refundable=${query.refundable}`;
    }
    if (query.userSpends != null && query.userSpends.length != 0) {
      url = url + `&userSpends=${query.userSpends}`;
      if (query.userSpends === true) {
        if (query.spendsFrom != null && query.spendsFrom.length != 0) {
          url = url + `&spendsFrom=${query.spendsFrom}`;
        }
        if (query.spendsTo != null && query.spendsTo.length != 0) {
          url = url + `&spendsTo=${query.spendsTo}`;
        }
      }
    }

    if (query.search != null && query.search.length != 0) {
      url = url + `&search=${query.search}`;
    }
    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${accessToken}` }
    });

    if (response.data.status === 'ok') {
      return { status: 'ok', data: response.data.data };
    } else {
      throw new Error(response.data.message);
    }
  }

  static async create(serviceRecord) {
    const accessToken = JSON.parse(localStorage.getItem('accessToken'));
    let url = `${adminUrl}/services-records`;

    const response = await axios.post(url, serviceRecord, {
      headers: { Authorization: `Bearer ${accessToken}` }
    });
    if (response.data.status === 'ok') {
      return { status: 'ok', data: response.data.data };
    } else {
      throw new Error(response.data.message);
    }
  }
  // Edición en el módulo admin (024-services-record-edit, contracts/services-record-update.md).
  // A diferencia de getAll/create de arriba, no lanza: devuelve { status, data } o
  // { status: 'error', message, code, httpCode } para que el modal mapee el error.
  static async update(serviceRecordId, changes) {
    const accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try {
      const response = await axios.patch(`${adminUrl}/services-records/${serviceRecordId}`, changes, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      return { status: 'ok', data: response.data.data };
    } catch (error) {
      return {
        status: 'error',
        message: error.response?.data?.message ?? error.message,
        code: error.response?.data?.code,
        httpCode: error.response?.status
      };
    }
  }
  // Atención actual de un registro PetMed, para precargar el formulario al rehacerla.
  static async getAttendance(serviceRecordId) {
    const accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try {
      const response = await axios.get(`${adminUrl}/services-records/${serviceRecordId}/attendance`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      return { status: 'ok', data: response.data.data };
    } catch (error) {
      return {
        status: 'error',
        message: error.response?.data?.message ?? error.message,
        httpCode: error.response?.status
      };
    }
  }
  /**
   * Reduced customer search for admins without `*` (spec 131): exact RUT or exact
   * email, never free text. The RUT/email travel in the body, never in the URL.
   * The response carries no RUT or email.
   *
   * @param {{ rut: string } | { email: string }} body
   * @returns {Promise<{ status: 'ok', data: object[] }>} throws on HTTP errors, like `getAll`.
   */
  static async customerLookup(body) {
    const accessToken = JSON.parse(localStorage.getItem('accessToken'));
    const response = await axios.post(`${adminUrl}/services-records/customer-lookup`, body, {
      headers: { Authorization: `Bearer ${accessToken}` }
    });
    return { status: 'ok', data: response.data.data || [] };
  }
  static async delete(serviceRecordId) {
    const accessToken = JSON.parse(localStorage.getItem('accessToken'));
    let url = `${adminUrl}/services-records/${serviceRecordId}`;

    const response = await axios.delete(url, {
      headers: { Authorization: `Bearer ${accessToken}` }
    });
    if (response.data.status === 'ok') {
      return { status: 'ok', data: response.data.data };
    } else {
      throw new Error(response.data.message);
    }
  }
}
